// src/utils/ErrorBoundary.js
import React from "react"
import { reportClientError } from "../utils/clientErrorReporter"
import { parseErrorStack } from "../utils/parseStack"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  async componentDidCatch(error, info) {
    console.error("React ErrorBoundary:", error, info)

    const trace = parseErrorStack(error?.stack)

    reportClientError({
      type: "react_error",
      message: error?.message,
      stack: error?.stack || null,
      component_stack: info?.componentStack || null,
      url: window.location.href,
      user_agent: navigator.userAgent,
      user: window.appUser?.id || "anonymous",
      organization_id: window.appUser?.organization_id || "",
      enterprise_id: window.appUser?.enterprise_id || "",
      participant_id: window.appUser?.participant_id || "",
      release: process.env.REACT_APP_BUILD_ID || "unknown",
      environment: process.env.NODE_ENV,
      timestamp: Date.now(),
      ...trace,
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f8fafc",
            padding: "24px",
            fontFamily: `system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial`,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "50px",
              borderRadius: "18px",
              maxWidth: "620px",
              width: "100%",
              textAlign: "center",
              boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
              border: "1px solid #e2e8f0",
            }}
          >
            <div style={{ color: "#dc2626", margin: "0 auto", width: "50px", paddingBottom: "20px" }}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                margin="0 auto"
                stroke="#dc2626"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "700",
                color: "#1e293b",
                marginBottom: "14px",
              }}
            >
              Something went wrong
            </h2>

            <p
              style={{
                fontSize: "20px",
                color: "#475569",
                marginBottom: "28px",
                lineHeight: "1.7",
              }}
            >
              RecoveryLink experienced an unexpected and unrecoverable error.
              <br />
              <br />
              We have logged the issue, but please notify{" "}
              <a href="mailto:support@myrecoverylink.com" style={{ color: "#2563eb" }}>
                support@myrecoverylink.com
              </a>{" "}
              to report what action you were performing when this error occurred.
            </p>

            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "12px 20px",
                background: "rgb(132 103 173)",
                border: "none",
                color: "white",
                fontSize: "23px",
                fontWeight: "600",
                borderRadius: "10px",
                cursor: "pointer",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                transition: "background 0.2s",
              }}
              onMouseOver={(e) =>
                (e.target.style.background = "rgb(113 85 150)")
              }
              onMouseOut={(e) =>
                (e.target.style.background = "rgb(132 103 173)")
              }
            >
              Reload Page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary